import { UIComponentProps, UIComponentState, UIComponentHandler, UIComponentImpl, UIDataModel } from '../uicomponent';
import { UIComponentView } from '../uicomponentview';
import { FileUploadView } from './fileuploadview';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentCSSStyle } from '../uicomponentcss';
import { FileUploadCSSStyleImpl } from './fileuploadcss';


export interface FileUploadProps extends UIComponentProps
{
    isMultipleFilesAllowed: boolean;
    buttonTitle: string;
    extentionsAccepted: string;  
    // minAllowedSize: number;
    // maxAllowedSize: number;
    fileUploadStatus: FileUploadStatus;
    onFileSelected(): void;
}

export interface FileUploadState extends UIComponentState
{
    fileName: string;
    buttonTitle: string;
    fileUploadStatus: FileUploadStatus;
}

export enum FileUploadStatus
{
    FILE_UPLOAD, FILE_PREVIEW, FILE_UPLOADING, FILE_UPLOADED, FILE_UPLOAD_FAILED
}

export interface FileUploadHandler extends UIComponentHandler
{
    onSelectFile(fileName: string): void;
}

export class FileUploadComponent extends UIComponentImpl<FileUploadProps, FileUploadState, UIDataModel> implements FileUploadHandler
{
    constructor(props: FileUploadProps)
    {
        super(props);

        this.state = {fileName: "", fileUploadStatus: props.fileUploadStatus,buttonTitle: props.buttonTitle};
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new FileUploadView(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new FileUploadCSSStyleImpl(applicationContext);
    }

    componentWillReceiveProps(nextProps: FileUploadProps)
    {
        this.setState({fileUploadStatus: nextProps.fileUploadStatus, buttonTitle: nextProps.buttonTitle});
    }

    // getData()
    // {
    //    return new FormItemModel(DataValueFactory.
    //         createDataValue(DataValueTypes.USER_DEFINED, 0, (this.getView() as FileUploadView).getData()));
    // }

    triggerUpload()
    {
        (this.state.fileUploadStatus === FileUploadStatus.FILE_UPLOAD || 
        this.state.fileUploadStatus === FileUploadStatus.FILE_UPLOAD_FAILED) 
        && (this.getView() as FileUploadView).onUploadButtonClick();
    }

    validate(): boolean
    {
       return (this.getView() as FileUploadView).validate();
    }

    setFileUploadStatus(status: FileUploadStatus): void 
    {
        this.setState({fileUploadStatus: status});
    }

    onSelectFile(fileName: string)
    {
        this.setState({fileName: fileName});

        this.props.onFileSelected();
    }

    clearData()
    {
        this.setState({fileName: ""});
        this.getView().clearData();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/fileupload/fileuploadcomponent.tsx